import { UserTypeConstants } from '../types/UserTypeConstants';
let initialState = {
  adminList:[],
  profile:{},
  secretQuestion:[],
  secretQuestionUpdated:false
}
export function admin(state = initialState, action) {
  switch (action.type) {
    case UserTypeConstants.ADMIN_GETALL_SUCCESS:{
       state.adminList=action.data;
       return state;
    }case UserTypeConstants.GET_USER_BY_ID_SUCCESS:{
      state.secretQuestionUpdated=false;
      state.profile=action.data;
      return state;
   }case UserTypeConstants.GET_SECRET_QUESTION_REQUEST:{
    state.secretQuestion=[];
    state.secretQuestionUpdated=false;
    return state;
   }case UserTypeConstants.GET_SECRET_QUESTION_FAILIURE:{
    state.secretQuestion=[];
    state.secretQuestion=action.data;
    return state;
   }case UserTypeConstants.GET_SECRET_QUESTION_SUCCESS:{
    state.secretQuestion=action.data;
    return state;
   }case UserTypeConstants.UPDATE_SECRET_QUESTION_REQUEST:{
    state.secretQuestionUpdated=false;
    return state;
   }case UserTypeConstants.UPDATE_SECRET_QUESTION_SUCCESS:{
    state.secretQuestionUpdated=true;
    return state;
   }case UserTypeConstants.CLEAR_ADMIN:{
    state.adminList = [];
    state.profile = {};
    state.secretQuestion = [];
    state.secretQuestionUpdated = false;
    return state;
   }default:
    return state
  }
}